import { get, post } from '../../ReaderlyHttpClient';
import { PriceType } from '../Data';
import { DeliveryInformationData } from '../UserService/Data';

export interface CreateOrderItemData {
  itemId: number;
  count: number;
}

export interface CreateOrderData {
  userComment: string;
  userDeliveryInformationId: number;
  items: CreateOrderItemData[];
}

export interface OrderItemData extends CreateOrderItemData {
  name: string;
  price: number;
  priceType: PriceType;
}

export interface OrderData {
  id: number;
  orderDate: string;
  totalPrice: number;
  orderStatus: number;
  deliveryType: number;
  userComment: string;
  comment: string;
  deliveryInformation: number;
  trackingNumber?: string;
  userDeliveryInformation?: DeliveryInformationData;
  items: OrderItemData[];
}

export interface OrderHistoryResponse {
  items: OrderData[];
  totalCount: number;
}

class OrderService {
  async createOrder(data: CreateOrderData): Promise<OrderData> {
    return await post<OrderData, CreateOrderData>('api/Order', data);
  }

  async getHistory(index = 0, count = 20): Promise<OrderHistoryResponse> {
    return await get<OrderHistoryResponse>('api/Order', { index, count });
  }
}

const orderServiceInstance = new OrderService();
export default orderServiceInstance;
